/**
 * Tire filter data - all available values for each wizard step.
 */

const TIRE_DATA = {
  widths: [
    125, 135, 145, 155, 165, 175, 185, 195,
    205, 215, 225, 235, 245, 255, 265, 275,
    285, 295, 305, 315, 325, 335, 345, 355,
    365, 375, 385, 395
  ],

  heights: [
    25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85
  ],

  inches: [
    12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
  ],

  loadIndices: [
    { code: 68, maxKg: 315 },
    { code: 69, maxKg: 325 },
    { code: 70, maxKg:335 },
    { code: 71, maxKg: 345 },
    { code: 72, maxKg: 355 },
    { code: 73, maxKg: 365 },
    { code: 74, maxKg: 375 },
    { code: 75, maxKg: 387 },
    { code: 79, maxKg: 437 },
    { code: 80, maxKg: 450 },
    { code: 81, maxKg: 462 },
    { code: 82, maxKg: 475 },
    { code: 83, maxKg: 487 },
    { code: 84, maxKg: 500 },
    { code: 85, maxKg: 515 },
    { code: 86, maxKg: 530 },
    { code: 87, maxKg: 545 },
    { code: 88, maxKg: 560 },
    { code: 89, maxKg: 580 },
    { code: 90, maxKg: 600 },
    { code: 91, maxKg: 615 },
    { code: 92, maxKg: 630 },
    { code: 93, maxKg: 645 },
    { code: 94, maxKg: 670 },
    { code: 95, maxKg: 690 },
    { code: 96, maxKg: 710 },
    { code: 97, maxKg: 730 },
    { code: 98, maxKg: 750 },
    { code: 99, maxKg: 775 },
    { code: 100, maxKg: 800 },
    { code: 101, maxKg: 825 },
    { code: 102, maxKg: 850 },
    { code: 103, maxKg: 875 },
    { code: 104, maxKg: 900 },
    { code: 105, maxKg: 925 },
    { code: 106, maxKg: 950 },
    { code: 107, maxKg: 975 },
    { code: 108, maxKg: 1000 },
    { code: 110, maxKg: 1060 },
    { code: 111, maxKg: 1085 },
    { code: 112, maxKg: 1120 },
    { code: 113, maxKg: 1150 },
    { code: 114, maxKg: 1180 },
    { code: 115, maxKg: 1210 },
    { code: 116, maxKg: 1250 },
    { code: 117, maxKg: 1285 },
    { code: 118, maxKg: 1320 },
    { code: 119, maxKg: 1355 },
    { code: 120, maxKg: 1400 },
    { code: 121, maxKg: 1450 },
    { code: 122, maxKg: 1500 },
    { code: 123, maxKg: 1550 },
    { code: 124, maxKg: 1600 },
    { code: 125, maxKg: 1650 },
    { code: 126, maxKg: 1700 },
    { code: 127, maxKg: 1750 },
    { code: 128, maxKg: 1800 },
    { code: 129, maxKg: 1850 },
    { code: 130, maxKg: 1900 },
    { code: 131, maxKg: 1950 },
    { code: 132, maxKg: 2000 },
    { code: 133, maxKg: 2060 },
    { code: 134, maxKg: 2120 },
    { code: 135, maxKg: 2180 },
    { code: 136, maxKg: 2240 },
    { code: 137, maxKg: 2300 },
    { code: 138, maxKg: 2360 },
    { code: 139, maxKg: 2430 },
    { code: 140, maxKg: 2500 },
    { code: 141, maxKg: 2575 },
    { code: 142, maxKg: 2650 },
    { code: 143, maxKg: 2725 },
    { code: 144, maxKg: 2800 },
    { code: 145, maxKg: 2900 },
    { code: 146, maxKg: 3000 },
    { code: 147, maxKg: 3075 },
    { code: 148, maxKg: 3150 },
    { code: 149, maxKg: 3250 },
    { code: 150, maxKg: 3350 },
    { code: 151, maxKg: 3450 },
    { code: 152, maxKg: 3550 },
    { code: 153, maxKg: 3650 },
    { code: 154, maxKg: 3750 },
    { code: 155, maxKg: 3875 },
    { code: 156, maxKg: 4000 },
    { code: 157, maxKg: 4125 },
    { code: 158, maxKg: 4250 },
    { code: 159, maxKg: 4375 },
    { code: 160, maxKg: 4500 },
    { code: 161, maxKg: 4625 },
    { code: 162, maxKg: 4750 },
    { code: 163, maxKg: 4875 },
    { code: 164, maxKg: 5000 },
    { code: 165, maxKg: 5150 },
    { code: 166, maxKg: 5300 },
    { code: 167, maxKg: 5450 },
    { code: 168, maxKg: 5600 },
    { code: 169, maxKg: 5800 },
    { code: 170, maxKg: 6000 },
  ],

  speedIndices: [
    { code: 'B', maxKmh: 50 },
    { code: 'C', maxKmh: 60 },
    { code: 'D', maxKmh: 65 },
    { code: 'E', maxKmh: 70 },
    { code: 'F', maxKmh: 80 },
    { code: 'G', maxKmh: 90 },
    { code: 'J', maxKmh: 100 },
    { code: 'K', maxKmh: 110 },
    { code: 'L', maxKmh: 120 },
    { code: 'M', maxKmh: 130 },
    { code: 'N', maxKmh: 140 },
    { code: 'P', maxKmh: 150 },
    { code: 'Q', maxKmh: 160 },
    { code: 'R', maxKmh: 170 },
    { code: 'S', maxKmh: 180 },
    { code: 'T', maxKmh: 190 },
    { code: 'U', maxKmh: 200 },
    { code: 'H', maxKmh: 210 },
    { code: 'V', maxKmh: 240 },
    { code: 'W', maxKmh: 270 },
    { code: 'Y', maxKmh: 300 },
    { code: 'ZR', maxKmh: 300 },
  ],

  seasons: [
    { id: 'all-season', label: 'All Season', icon: '☀❄' },
    { id: 'summer', label: 'Summer', icon: '☀️' },
    { id: 'winter', label: 'Winter', icon: '❄️' },
  ],

  steps: [
    { key: 'width',  label: 'Width',  unit: 'mm', paramName: 'filter.v.m.tire.width' },
    { key: 'height', label: 'Height', unit: '',   paramName: 'filter.v.m.tire.height' },
    { key: 'inch',   label: 'Inch',   unit: '"',  paramName: 'filter.v.m.tire.inch' },
    { key: 'load',   label: 'Load',   unit: '',   paramName: 'filter.v.m.tire.load_index' },
    { key: 'speed',  label: 'Speed',  unit: '',   paramName: 'filter.v.m.tire.speed_rating' },
  ]
};
